import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const StarSixPoint = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="six point star icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M11.0138 0.601312C11.4268 -0.200437 12.5732 -0.200438 12.9862 0.601312L15.0568 4.62027L19.3627 3.24255C20.2217 2.9677 21.0323 3.77827 20.7575 4.63727L19.3797 8.94322L23.3987 11.0138C24.2004 11.4268 24.2004 12.5732 23.3987 12.9862L19.3797 15.0568L20.7575 19.3627C21.0323 20.2217 20.2217 21.0323 19.3627 20.7575L15.0568 19.3797L12.9862 23.3987C12.5732 24.2004 11.4268 24.2004 11.0138 23.3987L8.94322 19.3797L4.63727 20.7575C3.77827 21.0323 2.9677 20.2217 3.24255 19.3627L4.62027 15.0568L0.601312 12.9862C-0.200437 12.5732 -0.200438 11.4268 0.601312 11.0138L4.62027 8.94322L3.24255 4.63727C2.9677 3.77827 3.77827 2.9677 4.63727 3.24255L8.94322 4.62027L11.0138 0.601312Z"
    />
  </svg>
)
